export default __webpack_public_path__ + "static/media/ListActive.33315257.svg";